<template>
  <div id="extra-switch-wrapper">
    <p
      class="before-text"
      ref="before-text"
      :class="switchValue === leftValue ? 'active' : ''"
      @mouseup="setLeft"
    >
      {{ beforeText }}
    </p>
    <div class="switch-toggle" ref="switch-toggle">
      <div
        :class="['left-side part', { active: switchValue === leftValue }]"
        @mouseup="setLeft"
      ></div>

      <!-- <div class="center-side part" @click="setCenter"></div> -->
      <div class="center-side part"></div>

      <div
        :class="['right-side part', { active: switchValue === rightValue }]"
        @mouseup="setRight"
      ></div>
    </div>
    <p
      class="after-text"
      ref="after-text"
      :class="this.switchValue === rightValue ? 'active' : ''"
      @mouseup="setRight"
    >
      {{ afterText }}
    </p>
  </div>
</template>

<script>
export default {
  name: "ExtraSwitch",
  props: {
    fontSize: {
      type: String,
      required: false,
      default: "14px"
    },
    leftValue: {
      required: false,
      default: 0
    },
    rightValue: {
      required: false,
      default: 1
    },
    beforeText: {
      type: String,
      required: false,
      default: ""
    },
    afterText: {
      type: String,
      required: false,
      default: ""
    },
    value: {
      required: false,
      default: undefined
    }
  },
  data() {
    return {
      switchValue: this.value
    };
  },
  mounted() {
    this.initSwitch();
    this.$refs["before-text"].style["font-size"] = this.fontSize;
    this.$refs["after-text"].style["font-size"] = this.fontSize;
  },
  methods: {
    setCenter() {
      this.switchValue = undefined;
    },
    setLeft() {
      this.switchValue = this.leftValue;
    },
    setRight() {
      this.switchValue = this.rightValue;
    },
    initSwitch() {
      if (this.switchValue === this.leftValue) {
        this.$refs["switch-toggle"].classList.add("left");
        this.$refs["switch-toggle"].classList.remove("right");
      } else if (this.switchValue === this.rightValue) {
        this.$refs["switch-toggle"].classList.remove("left");
        this.$refs["switch-toggle"].classList.add("right");
      } else {
        this.$refs["switch-toggle"].classList.remove("left");
        this.$refs["switch-toggle"].classList.remove("right");
      }
    }
  },
  watch: {
    switchValue() {
      this.initSwitch();
      this.$emit("input", this.switchValue);
    },
    value() {
      this.switchValue = this.value;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";
#extra-switch-wrapper {
  display: flex;
  align-items: center;
  .before-text {
    margin-right: 10px;
    text-align: right;
    cursor: pointer;
    &.active {
      color: $color-primary;
      font-weight: 550;
    }
  }
  .after-text {
    margin-left: 10px;
    cursor: pointer;
    &.active {
      color: $color-primary;
      font-weight: 550;
    }
  }
}
$toggle-background-color-off: darkgray;
$toggle-control-color: white;
$toggle-width: 75px;
$toggle-height: 25px;
$toggle-gutter: 5px;
$toggle-radius: 50%;
$toggle-control-speed: 0.3s;
$toggle-control-ease: ease-in;

// These are our computed variables
// change at your own risk.
$toggle-radius: $toggle-height / 2;
$toggle-control-size: $toggle-height - ($toggle-gutter * 2);

.switch-toggle {
  transform: rotate(90deg);
  display: flex;
  position: relative;
  cursor: pointer;
  user-select: none;
  height: $toggle-height;
  width: $toggle-width;
  border-radius: $toggle-radius;
  background-color: $toggle-background-color-off;
  transition: background-color $toggle-control-speed $toggle-control-ease;
  &:after {
    content: "";
    position: absolute;
    left: 30px;
    top: $toggle-gutter;
    width: $toggle-control-size;
    height: $toggle-control-size;
    border-radius: $toggle-radius;
    background: $toggle-control-color;
    transition: left $toggle-control-speed $toggle-control-ease;
  }
  .part {
    width: 25px;
    height: 100%;
  }
}
.left.switch-toggle {
  background-color: $color-success;
  &:after {
    left: $toggle-gutter;
  }
}

.right.switch-toggle {
  background-color: $color-danger;
  &:after {
    left: $toggle-width - $toggle-control-size - $toggle-gutter;
  }
}
</style>
